<template>
   <v-container fluid pa-0>
        <v-card>
            <v-toolbar>
                <v-toolbar-title>  
                    <v-icon>how_to_reg</v-icon>  Status
                </v-toolbar-title>
                <v-spacer />
                <v-chip color="green" text-color="white">
                    <v-avatar class="green darken-4"><b>{{ this.teachersIncomplete }}</b></v-avatar>
                    Teachers Incomplete
                    <v-btn round style="margin-right: -9px" small @click="loadTeachersDialog()" v-bind:disabled="disabled">Send Reminder</v-btn>
                </v-chip>
                <v-chip color="green" text-color="white">
                    <v-avatar class="green darken-4"><b>{{ this.studentsIncomplete }}</b></v-avatar>
                     Students Incomplete
                    <v-btn round style="margin-right: -11px" small @click="loadStudentsDialog()" v-bind:disabled="disabled">Send Reminder</v-btn>
                </v-chip>
                
                <v-btn @click="downloadMissing()">Download Missing</v-btn>
            </v-toolbar>
            <v-toolbar class="elevation-1">
     
                <v-flex xs2>
                    <v-text-field
                        append-icon="search"
                        label="Search"
                        flat
                        v-model="search"
                        solo
                        :disabled="loading"
                    ></v-text-field>
                </v-flex>

                <status-filters v-on:filter-selected="filterSelected" :disabled="loading"></status-filters>

                <v-spacer></v-spacer>
                <v-btn @click="selectNotComplete()" v-bind:disabled="disabled">Select all</v-btn>

                
                <v-btn @click="loadReminderDialog()" v-bind:disabled="disabled">Send Reminder</v-btn>
                
            </v-toolbar>
            <v-data-table 
                :headers="headers"
                :items="items"
                :search="search"
                :pagination.sync="pagination"
                :total-items="totalItems"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
                class="elevation-1">

                <template slot="items" slot-scope="props">
                    <td><v-checkbox v-model="props.item.isComplete" disabled></v-checkbox></td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.role }}</td>
                    <td>{{ props.item.year }}</td>
                    <td>{{ props.item.cohort }}</td>
                    <td>
                        <v-checkbox v-model="selected" :value="props.item.email" v-bind:disabled="disabled" ></v-checkbox>
                    </td>
                    <td>
                        <v-btn color="primary" flat  small :to="makeLink(props.item)">
                            Effort Grades <v-icon small right>assignment_turned_in</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>    
        <v-dialog v-model="dialog" max-width="65%">
            <v-card>
            <v-card-title>
                Reminder message for selected items
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                    <v-flex xs12>
                    <v-text-field
                        label="Subject"
                        v-model="reminderSubject"
                        required
                    ></v-text-field>
                    </v-flex>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                   <v-textarea
                        height="5em"
                        name="input-7-1"
                        label="Message"
                        v-model="reminderMessage"
                        required
                    ></v-textarea>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="dialog=false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.native="sendReminders(selected)">Send</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="teacherdialog" max-width="60%">
            <v-card>
            <v-card-title>
                Reminder message for teachers
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                    <v-flex xs12>
                    <v-text-field
                        label="Subject"
                        v-model="reminderSubject"
                        required
                    ></v-text-field>
                    </v-flex>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                     <v-textarea
                        height="5em"
                        name="input-7-1"
                        label="Message"
                        v-model="reminderMessage"
                        required
                    ></v-textarea>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="teacherdialog=false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.native="sendReminders(teachersNotComplete)">Send</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="studentdialog" max-width="65%">
            <v-card>
            <v-card-title>
                Reminder message for students
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                    <v-flex xs12>
                    <v-text-field
                        label="Subject"
                        v-model="reminderSubject"
                        required
                    ></v-text-field>
                    </v-flex>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-text>
                <v-layout row wrap>
                <v-flex xs12 class="my-3">
                    <v-textarea
                        height="5em"
                        name="input-7-1"
                        label="Message"
                        v-model="reminderMessage"
                        required
                    ></v-textarea>
                </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" flat @click.stop="studentdialog=false">Close</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.native="sendReminders(studentsNotComplete)">Send</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
   </v-container>
    
</template>

<script>
    import { getEffortTrackingStatus, sendReminderFromAPI, getFilteredStatus } from '../utils/effort-tracking-api';
    import {  getMissingReport, getCsvFile, downloadFile, initialize, getReportingPeriodStatus } from '../utils/effort-tracking-api';
    import { globalStore } from '../main';
    import StatusFilters from '../components/StatusFilters';

    export default {
        components: {
            StatusFilters
        },
        data() {
            return {
                search: '',
                page: 0,
                items: [],
                loading: true,
                totalItems: 0,
                rowsPerPageItems: globalStore.rowsPerPageItems ,
                pagination: { rowsPerPage: globalStore.defaultRowsPerPage },
                headers: [
                    { text: 'Completed', value: 'isComplete' },
                    { text: 'Name', value: 'name' },
                    { text: 'Role', value: 'role' },
                    { text: 'Year', value: 'year' },
                    { text: 'Cohort', value: 'cohort' },
                    { text: "Send reminder", value: 'email'},
                    { text: '', value: '', sortable: false },
                ],
                selected: [],
                notCompleted: [],
                dialog: false,
                teacherdialog: false,
                studentdialog: false,
                reminderMessage: this.makeMessage(),
                selectedRole: '',
                selectedCohort: '',
                appUrl: 'https://staging.efforttracking.app',
                totalIncomplete: 0,
                studentsIncomplete: 0,
                teachersIncomplete: 0,
                studentsNotComplete: [],
                teachersNotComplete: [],
                reminderSubject: 'Effort Grading Reminder',
                disabled: this.isDisabled()
            }
        },
        watch: {
            search: {
                handler () {
                    this.debouncedGetDataFromApi
                },
            },
            pagination: {
                handler () {
                    this.debouncedGetDataFromApi
                },
                deep: true
            }
        },
        mounted () {
            initialize().then(x => {
               this.debouncedGetDataFromApi = this.getDataFromApi(); 
            });
        },

        methods: {
            makeMessage() {
                return '\n This is a reminder that you have not completed your effort grading. '
                +'\n Please log in with your email address and password and complete your grades as soon as possible';
            },
            isDisabled() {
                var periodId = localStorage.getItem('period-selected');
                initialize().then(x => {
                    getReportingPeriodStatus().then(result => {  
                        var readonly = !result.active || result.complete;
                        return readonly;
                    }).catch(ex => console.log(ex));

                    return false;
                });
            },
            getDataFromApi () {
                this.loading = true;
                getEffortTrackingStatus()
                .then(data => {
                    console.log(data);
                    this.totalIncomplete = data.notComplete.length;

                    // Incomplete students
                    var snc = data.notComplete.filter(x => x.role == 'Student');
                    this.studentsIncomplete = snc.length;
                    this.studentsNotComplete = snc.map(s => s.email);

                    // Incomplete teachers
                    var tnc = data.notComplete.filter(x => x.role == 'Teacher');
                    this.teachersIncomplete = tnc.length;
                    this.teachersNotComplete = tnc.map(t => t.email);
                    this.items = data.results
                    this.totalItems = data.results.count
                    this.notCompleted = data.notComplete.map(nc => nc.email);
                    this.loading = false;
                })
            },
            loadTeachersDialog() {
                this.teacherdialog = true;
            },
            loadStudentsDialog() {
                this.studentdialog = true;
            },
            loadReminderDialog() {
                if(this.selected.length > 0)
                    this.dialog = true;
            },

            sendReminders(itemsSelected) {
                this.dialog = false;
                this.teacherdialog = false;
                this.studentdialog = false;

                sendReminderFromAPI(itemsSelected, this.reminderSubject, this.reminderMessage)
                    .then(response => { 
                        this.reminderSubject = 'Effort Grading Reminder';
                        this.reminderMessage = this.makeMessage();
                    });
            },

            selectNotComplete() {
                if (this.selected.length == 0) {
                    this.selected = this.notCompleted
                } else {
                    this.selected = []
                }
            },

            filterSelected(role, year, cohort) {
                this.loading = true;
                getFilteredStatus(role, year, cohort)
                .then(data => {
                        this.items = data.results;
                        this.totalItems = data.results.count;
                        this.notCompleted = data.notComplete;
                        this.loading = false;
                        this.selectedRole = role;
                        
                        if(role == 'Teacher')
                        {
                             this.selectedCohort = 'undefined';   
                             this.selectedYear = 'undefined';   
                        }
                        else
                        {
                            this.selectedCohort = cohort;
                            this.selectedYear = year;
                        }

                    })
                .catch(ex => console.log(ex));
            },

            makeLink(item){
                if(item.role == 'Teacher')
                {
                    return { name: 'TeacherEfforts', params: { teacherId: item.id }}
                }

                if(item.role == 'Student') 
                {
                    return { name: 'StudentEfforts', params: { studentId: item.id }}
                }
            },

            downloadMissing(){
                var periodId = localStorage.getItem('period-selected');
                this.loading = true;
                var url = getMissingReport(periodId).then( fileName => 
                { 
                    this.loading = false;
                    var fileUrl = getCsvFile(fileName);
                    downloadFile(fileUrl, fileName);
                }).catch(ex => console.log(ex));
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Status.vue